  <!--
  画面名：計画策定選択画面
  画面概要：策定された計画書の選択や計画書の新規作成をする
  備考： 計画策定画面の表示項目は計画策定選択画面から受け取ったパラメータによって変わる。
-->

<!-- HTML -->
<template>
  <!-- ページ全体を囲う要素  -->
  <div class="wrapper">

    <!-- 計画策定選択画面のセクション -->
    <section class="planformulation">
      <v-toolbar flat color="white">
      <!-- ページタイトル -->
        <v-toolbar-title>
          <PageTitle :PageTitle="$language.LabelPlanFormulationList" />
        </v-toolbar-title>
        <v-spacer />
        <!-- ページ内コンテンツ -->
        <!-- ページ右上にボタンを配置 -->
        <div v-if="isAuth">
          <!-- 過去の計画書からコピーボタンとダイアログ -->
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <!-- 過去の計画書からコピーボタン -->
              <v-btn
                class="btn"
                v-on="on"
                small
              >{{$language.LabelPlanCopy}}
              </v-btn>
            </template>
            <!-- 過去の計画書からコピーボタンを押下された際に、表示されるダイアログの要素 -->
            <v-card>
              <!-- ダイアログのタイトル -->
              <v-card-title>
                <span class="headline">{{$language.MsgSelectedPlanFormulation}}</span>
              </v-card-title>
              <v-card-text>
                <!-- 策定された過去の計画書をセレクトボックスで表示 -->
                <v-select
                  v-model="selected"
                  :items="plan"
                  :placeholder="$language.LabelSelectedPlanFormulation"
                  item-value="id"
                  item-text="title"
                  return-object
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <!-- コピーして作成するボタン -->
                <v-btn color="blue darken-1" :disabled="!selected" flat @click="formatPlanStatus(selected, true)">{{$language.LabelCreateByCopy}}</v-btn>
                <!-- キャンセルボタン -->
                <v-btn color="blue darken-1" flat @click="dialog = false">{{$language.LabelClose}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- 追加ボタン -->
          <v-btn class="btn" @click="toSetting" small>{{$language.LabelAdd}}</v-btn>
        </div>
      </v-toolbar>

      <div class="content">
        <!-- 策定された計画を表示するエリア -->
        <div class="planArea" v-show="isLoading">
          <!-- 計画書をリスト表示 -->
          <div class="block">
            <ul>
              <li
                v-for="(element, index) in plan"
                :key="index"
                :class="{'incomplete':element.status != 20}"
              >
                <div
                  class="table"
                  @click="formatPlanStatus(element)"
                >
                    <!-- 文書のアイコン -->
                    <div class="iconFrame">
                      <div class="image"><img src="@/assets/images/document.svg"></div>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <!-- 計画書のタイトルを表示 -->
                    <div class="textFrame pl-3 pr-4">
                      <p>
                        {{element.title}}
                        <!-- 確定されていない計画書には（未設定項目あり）の文言を出力 -->
                        <span v-if="element.status !=20">{{$language.LabelIncomplete}}</span>
                      </p>
                    </div>
                </div>
                <v-btn v-if="isAuth" class="icon-btn" fab small color="#fff" @click="remove(element.id,index)">
                  <v-icon color="#1f4e9c">remove</v-icon>
                </v-btn>
              </li>
            </ul>
          </div>
          <!-- 食材・料理・グループ分け -->
          <div class="block mt-3">
            <ul>
              <li
                @click="toFoodGroup()"
              >
                <!-- 文書のアイコン -->
                <div class="iconFrame">
                  <div class="image"><img src="@/assets/images/recipemenu.svg"></div>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <!-- 計画書のタイトルを表示 -->
                <div class="textFrame pl-3 pr-4 ws-pre">
                  <p>{{$language.LabelFoodGroupNewLine}}</p>
                </div>
              </li>
            </ul>
          </div>
          <!-- 店舗マニュアル -->
          <div class="displayMethod">
            <v-layout>
              <div class="icon" :class="{active:isIconDisplay}" @click="changeDisplay('icon')"><img :src="getTabicon"></div>
              <div class="icon" :class="{active:!isIconDisplay}" @click="changeDisplay('list')"><img :src="getTablist"></div>
            </v-layout>
          </div>
          <div class="block" v-show="isIconDisplay">
            <ul>
              <li
                v-for="store of stores"
                :key="store.name"
                @click="toManualList(store.haccpresnumber__c, store.name)"
              >
                <!-- 文書のアイコン -->
                <div class="iconFrame">
                  <div class="image"><img src="@/assets/images/manual.svg"></div>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <!-- 店舗名を表示 -->
                <div class="textFrame m_font pl-3 pr-4">
                  <p>
                    {{store.name}}
                    <br />
                    {{$language.LabelStoreManual}}
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="storeTable" v-show="!isIconDisplay">
            <!--  検索要素  -->
            <v-flex class="serchBox" xs3 offset-9 style="margin-left: auto; margin-right: 0;">
              <v-text-field
                v-model="search"
                append-icon="search"
                placeholder="このリストを検索..."
                hide-details
              ></v-text-field>
            </v-flex>
            <v-data-table
              :headers="tableHeader"
              :items="getTableData"
              :items-per-page="-1"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <!-- 名称 -->
                <td class="noWrap">
                  {{ props.item.name }}
                </td>
                <!-- 業態 -->
                <td class="noWrap">
                  {{ props.item.category }}
                </td>
                <!-- エリア名 -->
                <td class="noWrap">
                  {{ props.item.area }}
                </td>
                <!-- 住所 -->
                <td class="noWrap">
                  {{ props.item.address }}
                </td>
                <td class="noWrap">
                  <a @click="toManualList(props.item.haccpresnumber__c)" class="link-text">
                    店舗マニュアル
                  </a>
                </td>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </section>
    <!-- 確認用ダイアログ -->
    <ConfirmDialog
      ref="refConfirmDialog"
      :msg="$language.MsgConfirmDelete"
      @submit="removeItem"
    />
    <!-- 保存用ダイアログ -->
    <SaveDialog
      :msg="msg"
      ref="refSaveDialog"
    />
  </div>
</template>
<!-- /HTML -->
<script>
// 子（外部）コンポーネント読み込み
// ページタイトル
import PageTitle from '@/components/parts/common/PageTitle'
// ページタイトル
import ConfirmDialog from '@/components/parts/common/ConfirmDialog'
// 保存用モーダル
import SaveDialog from '@/components/parts/common/SaveDialog'
import SystemAndManagement from '@/components/pages/common/SystemAndManagement'
import tabicon from '@/assets/images/tabicon.svg'
import tablist from '@/assets/images/tablist.svg'

export default {
  name: 'Planformulation',
  // コンポーネント内の変数を定義
  data () {
    return {
      // 過去の計画書からコピーボタンから選択された計画書
      selected: '',
      // 計画書のリスト
      plan: [],
      // ダイアログの表示判定
      dialog: false,
      // 今年度を格納する
      currentYear: '',
      // 店舗情報を格納
      stores: [],
      // ロード中
      isLoading: false,
      // ダイアログ表示メッセージ
      msg: '',
      // DBにアクセスするAPIのカウント
      accessCount: 0,
      // 権限判定
      isAuth: true,
      // 検索文字
      search: '',

      tableHeader: [
        {
          'text': '契約店舗名',
          'value': 'name'
        },
        {
          'text': '業態',
          'value': 'category'
        },
        {
          'text': 'エリア',
          'value': 'area'
        },
        {
          'text': '住所',
          'value': 'address'
        },
        {
          'text': '',
          'value': 'manual',
          'sortable': false
        }
      ],
      isIconDisplay: true
    }
  },
  // 使用コンポーネント
  components: {
    // ページタイトル
    PageTitle,
    // 確認ダイアログ
    ConfirmDialog,
    // 保存用モーダル
    SaveDialog,
    SystemAndManagement

  },
  // 画面表示時に実行する関数を設定
  created () {
    // 権限の判定（店舗責任者）
    let auth = this.$store.getters['auth/getAuth'].auth
    if (auth === 5) {
      this.isAuth = false
    }
    // DBから計画書取得
    this.setSelectPlan()
  },
  computed: {
    getTabicon () {
      return tabicon
    },
    getTablist () {
      return tablist
    },
    // テーブルデータ取得処理
    getTableData () {
      // リストデータを作成
      let returnData = this.filter(this.stores, this.search)
      // 返却
      return returnData
    }
  },
  // 関数群
  methods: {
    // 店舗マニュアルの表示方法を切り替える
    changeDisplay (val) {
      if (val === 'icon') {
        this.isIconDisplay = true
      } else {
        this.isIconDisplay = false
      }
    },
    // フィルター処理
    filter (datas, search) {
      return SystemAndManagement.filterMain(datas, search, ['sfid', 'haccpcomnumber__c'])
    },
    /*
     *「過去の計画書からコピー」ボタン押下後、
     * ダイアログに表示されている「コピーして作成」ボタンが押下された時に発火。
     * 選択された過去の計画書の情報をパラメータで計画策定画面に渡し遷移
     */
    formatPlanStatus (data, isCopy = false) {
      // 過去の計画書からコピーされた場合はdataにisCopy = trueを格納する
      if (isCopy) {
        data.title = data.title + '-コピー'
        data.status = 0
        data.oldId = data.id
        data.id = 0
      }
      data.isCopy = isCopy
      // 計画策定画面に遷移
      this.$router.push({ name: 'Setting', params: { data } })
    },
    // 計画策定画面に遷移
    toSetting () {
      this.$router.push({ name: 'Setting' })
    },
    // マニュアル一覧に遷移
    toManualList (id, name) {
      this.$router.push({ name: 'ManualList', params: { id, name } })
    },
    // 原材料・仕込み品・料理グループ分けに遷移
    toFoodGroup () {
      this.$router.push({ name: 'FoodGroup' })
    },
    // 計画書削除ダイアログを表示
    remove (intId, intIndex) {
      // DBから計画書を削除する処理
      this.$refs.refConfirmDialog.openDialog(intId, intIndex)
    },
    // DBのアクセス終了か判定
    loadComplete () {
      const maxCount = 2
      this.accessCount++
      if (maxCount === this.accessCount) {
        // プログレスバーの非表示
        this.$store.dispatch('setIsLoading', false)
      }
    },
    /*
     * API接続処理
     */
    // 計画書取得
    setSelectPlan () {
      let self = this
      function callbackSetPlan (response) {
        // 店舗情報修正
        self.setStore()
        // 衛星計画書一覧を変数:planに格納
        for (let i = 0; i < response.length; i++) {
          self.plan.push({
            id: response[i].id,
            title: response[i].title,
            organizationJson: response[i].organization_json_data,
            organizationUserData: response[i].organization_user_data,
            foodSafetyPolicy: response[i].food_safety_policy,
            flowDiagramId: response[i].flow_diagram_id,
            flowDiagramName: response[i].flow_diagram_name,
            flowDiagramJson: response[i].flow_diagram_json,
            status: response[i].status,
            planningDocument: response[i].planning_document,
            year: response[i].create_date.slice(0, 4),
            createDate: response[i].create_date,
            fixedDate: response[i].fixed_date,
            updateDate: response[i].update_date,
            // 669_LHLINK-944 差し替え・付則対応
            templatePlanDocName: response[i].template_planning_document_name,
            replacePlanDocName: response[i].replace_name,
            addedPlanDocName: response[i].added_name
          })
        }
        self.$forceUpdate()
        self.loadComplete()
      }
      let data = {}
      data.callback = callbackSetPlan
      this.$store.dispatch('managementFunction/actionSelectPlan', data)
    },
    // 事業者ごとの店舗を参照し格納する
    setStore () {
      let self = this
      function callbackSetStore (response) {
        // 事業者ごとの店舗一覧を格納する
        self.stores = response
        // 画面表示
        self.isLoading = true
        self.loadComplete()
      }
      let data = {}
      data.isPlan = true
      data.callback = callbackSetStore
      // 事業者ごとの店舗を参照する
      this.$store.dispatch('managementFunction/actionSelectStore', data)
    },
    // 計画書削除処理
    removeItem (intid, intIndex) {
      let self = this
      function callbackRemoveItem (response) {
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
        if (response.status === 200) {
          // 削除完了ダイアログ
          self.msg = self.$language.MsgDoneDelete
          // 削除が完了したときのダイアログ
          self.$refs.refSaveDialog.openDialog()
          // 計画書の配列から該当計画書を削除
          self.plan.splice(intIndex, 1)
        }
      }
      let data = {}
      data.id = intid
      data.callback = callbackRemoveItem
      data.isPlan = true
      // データベース連携を行い食材をデータベースから削除する
      this.$store.dispatch('managementFunction/actionDeletePlan', data)
    }
  }
}

</script>

<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/managementFunction/planformulation.scss';
</style>
<style lang="scss">
  @import '@/assets/scss/managementFunction/storeTable.scss';
</style>
